const a="BRL",c="produto:geral",e="product:calculateTaxes",t="product:calculateTaxes:changed";export{a as CURRENCY,c as GENERAL_PRODUCT,e as PRODUCT_CALCULATE_TAXES,t as PRODUCT_CALCULATE_TAXES_CHANGED};
